import { PortalNewsPageObj } from "scrivito/Objs/PortalNewsPage/PortalNewsPageObjClass"
import { useScrivitoPage } from "scrivito/hooks/useScrivitoPage"

import { useScrollController } from "features/scroll-management/model/useScrollController"

import { PortalNewsPage } from "./PortalNewsPage"
import { usePortalNewsPageModel } from "./model/usePortalNewsPageModel"

export interface PortalNewsPageModel {
  page: PortalNewsPageObj | null | undefined
}

export function PortalNewsPageConnector(props: PortalNewsPageModel) {
  useScrivitoPage()
  useScrollController()

  return <PortalNewsPage {...usePortalNewsPageModel(props)} />
}
